<script setup lang="ts">
// import gsap from 'gsap'
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

interface Props {
  title: string
  src: string | undefined
  srcFull: string | undefined
  width?: number
  height?: number
}

withDefaults(defineProps<Props>(), {
  width: 1920,
  height: 1080
})

const emit = defineEmits(['onClick', 'onEnded', 'onExit', 'onMouseEnter', 'onMouseLeave'])
const maskRef = ref<SVGElement | null>(null)

// const playerRef = ref(null)
// const isVideoFullView = ref(false)
// const { bodyLock, bodyUnlock } = useBodyLock()

const handlePlay = () => {
  // if (isVideoFullView.value) return
  emit('onClick')
  // bodyLock()
  /*
  gsap.to(window, {
    duration: 0.5,
    scrollTo: { y: '#home-content-scroll', autoKill: true },
    ease: 'expo.out'
  })

  if (!playerRef.value) return
  playerRef.value.player?.play()
  */
  // isVideoFullView.value = true
}

/*
const handleEnded = () => {
  emit('onEnded', playerRef.value)
  isVideoFullView.value = false
  bodyUnlock()
}

const handleExit = () => {
  emit('onExit')
  isVideoFullView.value = false
  bodyUnlock()

  if (!playerRef.value) return
  playerRef.value.player?.pause()
}

const isCloseButtonVisible = ref(true)

onMounted(() => {
  gsap.registerPlugin(ScrollToPlugin)
})
*/
</script>

<template>
  <div class="absolute left-0 top-0 h-full w-full">
    <svg ref="maskRef" class="fx-mask-svg" width="1" height="1" viewBox="0 0 1 1" fill="none">
      <defs>
        <clipPath id="clip-mask" class="fx-mask-group" clipPathUnits="objectBoundingBox">
          <path
            transform="scale(1.8, 2.2) translate(-0.1 -0.195) rotate(15 0 0)"
            class="fx-mask-path"
            d="M0.573627 0.323593C0.573627 0.323593 0.535666 0.259863 0.51376 0.222865C0.509389 0.215482 0.505049 0.208639 0.5009 0.201908C0.468773 0.149714 0.408906 0.154711 0.390625 0.163081L0.391213 0.162094L0.406712 0.136045C0.448918 0.0653287 0.551244 0.0653287 0.593434 0.136045L0.74787 0.395026C0.77003 0.432198 0.743276 0.479364 0.700037 0.479364C0.679244 0.479364 0.659993 0.468416 0.649342 0.450562L0.573627 0.323593Z"
          />
          <path
            transform="scale(1.8, 2.2) translate(-0.1 -0.195) rotate(15 0 0)"
            class="fx-mask-path"
            d="M0.250195 0.39704C0.250483 0.396469 0.250707 0.395835 0.251027 0.395296L0.358766 0.216489C0.371264 0.19545 0.394898 0.181641 0.421269 0.181641C0.446439 0.181641 0.468586 0.194562 0.481419 0.214031C0.482827 0.216156 0.482587 0.21568 0.484939 0.219263C0.485755 0.220579 0.486651 0.222101 0.487483 0.223496L0.430662 0.317767L0.426405 0.324854C0.426949 0.324696 0.427493 0.324537 0.428037 0.324379C0.488684 0.306986 0.55349 0.333432 0.585845 0.387147C0.605816 0.420282 0.625674 0.45326 0.625674 0.45326C0.588054 0.434139 0.535616 0.421773 0.490428 0.421773C0.388593 0.421773 0.354238 0.466419 0.315418 0.477057C0.314714 0.477263 0.313994 0.477422 0.313274 0.477596C0.311386 0.478056 0.309481 0.478437 0.307561 0.478722C0.307049 0.478801 0.306537 0.478833 0.306025 0.478896C0.303801 0.479166 0.301545 0.47934 0.29924 0.47934C0.256372 0.479324 0.229713 0.43379 0.250195 0.39704Z"
          />
          <!-- 
          <rect
            class="fx-mask-path"
            width="0.3"
            height="0.3"
            x="0.5"
            y="0.5"
            transform="translate(-0.15, -0.15)"
            fill="blue"
          />
          -->
        </clipPath>
      </defs>
    </svg>
    <div
      class="fx-video-mask absolute left-1/2 top-1/2 h-[250px] w-[324px] origin-center -translate-x-1/2 -translate-y-1/2 cursor-pointer object-cover [clip-path:url(#clip-mask)] lg:h-[526px] lg:w-[680px]"
      @click="handlePlay"
      @mouseenter="$emit('onMouseEnter')"
      @mouseleave="$emit('onMouseLeave')"
    >
      <VideoLoop
        :src="src"
        :width="width"
        :height="height"
        class="absolute h-full w-full object-cover"
      />
      <!-- 
      <VideoPlayer
        v-show="isVideoFullView"
        ref="playerRef"
        class="absolute h-screen w-screen object-cover"
        :options="{
          controls: true,
          sources: [
            {
              src: srcFull,
              type: 'application/x-mpegURL'
            }
          ],
          preload: 'auto',
          fill: true,
          bigPlayButton: false,
          controlBar: {
            volumePanel: false,
            playToggle: false,
            fullscreenToggle: false,
            pictureInPictureToggle: false,
            currentTimeDisplay: false,
            remainingTimeDisplay: false
          }
        }"
        @useractive="isCloseButtonVisible = true"
        @userinactive="isCloseButtonVisible = false"
        @ended="handleEnded"
      >
      </VideoPlayer>
      -->
    </div>
    <div
      class="pointer-events-none absolute left-0 top-0 h-full w-full overflow-hidden lg:text-center"
    >
      <div class="container relative h-full lg:flex lg:flex-col lg:justify-center">
        <Heading
          v-if="title"
          class="fx-reel-heading pt-28 font-black leading-[0.84] tracking-tighter text-black opacity-70 mix-blend-overlay clamp-[2.2rem,10.5vw,6.25rem] lg:mx-auto lg:pt-0 lg:clamp-[4rem,11vw,10rem]"
          :size="undefined"
          :is-semantic="false"
        >
          <span class="fx-hero-title block" v-html="title" />
        </Heading>
      </div>
    </div>
    <!-- 
    <Transition name="button">
      <Button
        v-show="isVideoFullView && isCloseButtonVisible"
        variant="cta"
        class="!absolute right-4 top-4 z-[1] md:right-5 md:top-5 [&>span:last-child]:w-9 [&>span:last-child]:px-0 [&>span:last-child]:lg:w-10"
        type="button"
        @click="handleExit"
      >
        <Icon name="close" />
      </Button>
    </Transition>
    -->
  </div>
</template>
